define('org/forgerock/openam/ui/user/services/validateGotoService',["exports", "org/forgerock/commons/ui/common/main/AbstractDelegate", "org/forgerock/commons/ui/common/util/Constants"], function (exports, _AbstractDelegate, _Constants) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _AbstractDelegate2 = _interopRequireDefault(_AbstractDelegate);

    var _Constants2 = _interopRequireDefault(_Constants);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    /*
     * Copyright 2019 TOSIT.
     */

    /**
     * @module org/forgerock/openam/ui/user/services/validateGotoService
     */
    var validateGotoService = function validateGotoService(path) {
        // initialize service URL
        var serviceUrl = _Constants2.default.host + "/" + _Constants2.default.context + "/json/users";
        // initialize call parameters
        var type = "POST";
        var headers = { "Accept-API-Version": "protocol=1.0,resource=2.0" };
        var data = JSON.stringify({ "goto": decodeURIComponent(path) });
        var url = "?_action=validateGoto";
        var errorsHandlers = { "Bad Request": { status: 400 }, "Unauthorized": { status: 401 } };

        // call the service using call parameters
        return new _AbstractDelegate2.default(serviceUrl).serviceCall({
            type: type,
            headers: headers,
            data: data,
            url: url,
            errorsHandlers: errorsHandlers
        });
    };

    exports.default = validateGotoService;
});

